/* eslint-disable @nx/enforce-module-boundaries */
import { Injectable, inject } from '@angular/core';

import { CoreRunService } from '@frontend/oxygen/core';
import { BmaRunService } from '@frontend/oxygen/core-bma';
import { FavouritesRunService } from '@frontend/oxygen/core-favourites';
import { OnAppInit } from '@frontend/vanilla/core';

@Injectable({
    providedIn: 'root',
})
export class CoralHostAppService implements OnAppInit {
    private bmaRunService = inject(BmaRunService);
    private coreRunService = inject(CoreRunService);
    private favouritesRunService = inject(FavouritesRunService);

    onAppInit(): void {
        this.bmaRunService.init();
        this.coreRunService.init();
        this.favouritesRunService.run();
    }
}
